export var RestrictedDateDomain;
(function (RestrictedDateDomain) {
    RestrictedDateDomain[RestrictedDateDomain["Both"] = 0] = "Both";
    RestrictedDateDomain[RestrictedDateDomain["Federal"] = 1] = "Federal";
    RestrictedDateDomain[RestrictedDateDomain["Invest"] = 2] = "Invest";
    RestrictedDateDomain[RestrictedDateDomain["Wires"] = 3] = "Wires";
})(RestrictedDateDomain || (RestrictedDateDomain = {}));
export var RestrictedDateTransferType;
(function (RestrictedDateTransferType) {
    RestrictedDateTransferType[RestrictedDateTransferType["NotAllowed"] = 0] = "NotAllowed";
    RestrictedDateTransferType[RestrictedDateTransferType["Partial"] = 1] = "Partial";
    RestrictedDateTransferType[RestrictedDateTransferType["Allowed"] = 2] = "Allowed";
})(RestrictedDateTransferType || (RestrictedDateTransferType = {}));
//# sourceMappingURL=types.js.map